import React from "react";
import { Button as MuiButton } from "@mui/material";

interface ButtonProps {
  text: string;
  onClick?: () => void;
  type?: "button" | "submit";
  color?: "primary" | "secondary" | "success" | "error" | "info" | "warning";
}

const Button: React.FC<ButtonProps> = ({ text, onClick, type = "button" , color}) => {
  return (
    <MuiButton
      variant="contained"
      color={color}
      fullWidth
      sx={{ padding: "0.75rem" }}
      type={type}
      onClick={onClick}
    >
      {text}
    </MuiButton>
  );
};

export default Button;
